<template>
  <div @click="goToCommunity" class="main-container h-shadow-m shadow-s h-m-button mh-60" v-if="howToId">
    <img class="howTo-icon mh-40 hover-scale" alt="HowTo icon" src="@/assets/HowTo.svg" />
    <span class="link">
      {{ $t('shared.howToTile.community') }}
    </span>
  </div>
</template>

<script>
import config from '../../config'

export default {
  name: 'HowToTile',
  computed: {
    howToId() {
      return config.COMMUNITY_HOW_TO_ID
    }
  },
  methods: {
    goToCommunity() {
      this.$router.push({ name: 'communityPage', params: { id: this.howToId } })
    }
  }
}
</script>

<style scoped lang="scss">

.main-container {
  margin: 0 0 1rem 0;
  max-width: 280px;
  background-color: white;
  background-color: rgba(255,255,255,0.4);
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px;

  @media (max-width: $medium) {
    margin-left: 0;
    max-width: calc(100% - 20px) ;
    width: auto;
    margin-right: 0;
  }
  @media (max-width: $header-change) {
    width: 100%;
  }
}

.howTo-icon {
  width: 4em;
  height: auto;
  margin-right: 1em;
}
</style>
